import "../styles/Posters.css";

const postersData = [
  {
    file: require("../posters/4.jpg"),
    caption: "The Roxy",
    date: "27 May 2026",
  },
  {
    file: require("../posters/3.jpg"),
    caption: "Calamity Tank",
    date: "9 May 2026",
  },
  {
    file: require("../posters/2.jpg"),
    caption: "Calamity Tank",
    date: "4 Apr 2026",
  },
  {
    file: require("../posters/1.JPG"),
    caption: "Dingwalls2",
    date: "14 Mar 2026",
  },
];

export default function Posters() {
  return (
    <div className="posters">
      {postersData.map(({ file, caption, date }, index) => (
        <div>
          <img className="poster" src={file} alt={caption} />
          <div className="caption">
            <span>{caption}</span>
            <span className="date">{date}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
